import { useCallback } from "react";
import { useAPIAction,UserAccountApi } from "melco-shared-logic";
import { useParams } from "react-router-dom";

export const useUserProductAssign = ()=>{
   

    const { userId } = useParams<{
        userId: string;
    }>();

    const [assignProducts] = useAPIAction(UserAccountApi,
        async (api, productCode:string) => {

          
       

          const data = await api.accountProductsAllowProductAccess({ productCode });
        
          return {
            successMessages: [{ message: "default" }],
             data,
          };
        },
        {
          defaultApiConfigOptions: { impersonationForId: userId },
          translationPrefix: "users.products.actions.assign",
        }
      );

      return useCallback(
        async (productCode: string) => {
          const successfullyAssigned: string[] = [];
          try {  
            await  assignProducts(productCode);
            successfullyAssigned.push(productCode);
          }
          catch(e) {
            // exception already handled in useAPIAction
          }
              return successfullyAssigned;
        },
        [assignProducts]
      );


}